export const Input = {
  parts: ['field', 'addon'],
  baseStyles: {
    field: {
      _readOnly: {
        boxShadow: 'none !important',
        userSelect: 'all'
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
      },
      _invalid: {
        borderColor: 'brand.error',
        boxShadow: 'none'
      }
    },
    addon: {
      border: '1px solid',
      borderColor: 'brand.border',
      bg: 'brand.ghost'
    }
  },
  variants: {
    outline: {
      field: {
        border: '1px solid',
        background: 'inherit',
        borderRadius: 'var(--border-radius)',
        borderColor: 'brand.input-border',
        color: 'brand.text',
        _hover: {
          borderColor: 'brand.input-border'
        }
      },
      
    },
    monolith: {
      field: {
        borderWidth: '1px',
        background: 'brand.front',
        borderRadius: 'var(--border-radius)',
        boxShadow: 'sm',
        color: 'brand.text',
        _hover: {
          borderColor: 'brand.input-border'
        }
      },
    },
    transparent: {
      field: {
        border: '0',
        background: 'transparent',
        borderRadius: '0',
        borderColor: 'transparent',
        boxShadow: 'none',
        color: 'brand.text',
        pl: 8,
        _hover: {
          borderColor: 'transparent'
        }
      }
    },
    search: {
      field: {
        border: '0',
        background: 'transparent',
        borderRadius: '0',
        borderColor: 'transparent',
        boxShadow: 'none',
        color: 'brand.text',
        pl: 8,
        _hover: {
          borderColor: 'transparent'
        }
      }
    }
  },
  sizes: {
    field: {
      xs: {
        fontSize: 'xs',
        px: 2,
        h: 6
      },
      sm: {
        fontSize: 'sm',
        px: 3,
        h: 8
      },
      md: {
        fontSize: 'sm',
        px: 4,
        h: 9
      },
      lg: {
        fontSize: 'md',
        px: 4,
        h: 10
      }
    }
  },
  defaultProps: {
    size: 'md',
    variant: 'outline'
  }
}
